import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useStore } from '../../context/StoreContext';

const AdminLive = () => {
  const { liveSettings, setLiveSettings } = useStore();
  const [formData, setFormData] = useState(liveSettings);
  const [saved, setSaved] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLiveSettings(formData);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Live Stream Settings</h1>
        <p className="text-muted text-sm">Configure your Viloud live embed and schedule</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-dark-surface border border-dark-border rounded-xl p-6 space-y-6">
        
        <div className="flex items-center justify-between p-4 bg-dark-card border border-dark-border rounded-lg">
          <div>
            <h3 className="font-semibold">Stream Status</h3>
            <p className="text-sm text-muted">Toggle to show the live player on the frontend</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input 
              type="checkbox" 
              className="sr-only peer" 
              checked={formData.isLive}
              onChange={(e) => setFormData({...formData, isLive: e.target.checked})}
            />
            <div className="w-14 h-7 bg-dark-bg peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-danger border border-dark-border"></div>
          </label>
        </div>

        <div>
          <label className="block text-sm text-muted mb-1">Live Event Title</label>
          <input 
            type="text" 
            required
            value={formData.title}
            onChange={e => setFormData({...formData, title: e.target.value})}
            className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none"
          />
        </div>

        <div>
          <label className="block text-sm text-muted mb-1">Description / Notes</label>
          <textarea 
            required
            value={formData.description}
            onChange={e => setFormData({...formData, description: e.target.value})}
            className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none h-24"
          />
        </div>

        <div>
          <label className="block text-sm text-muted mb-1">Next Live At (Datetime)</label>
          <input 
            type="datetime-local" 
            required
            value={formData.nextLiveAt}
            onChange={e => setFormData({...formData, nextLiveAt: e.target.value})}
            className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none"
          />
        </div>

        <div>
          <label className="block text-sm text-muted mb-1">Viloud Live Stream Embed Link / HTML</label>
          <textarea 
            value={formData.embedHtml}
            onChange={e => setFormData({...formData, embedHtml: e.target.value})}
            className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none h-32 font-mono text-xs"
            placeholder='<iframe src="https://player.viloud.tv/..." width="100%" height="100%" frameborder="0" allowfullscreen></iframe>'
          />
          <p className="text-xs text-muted mt-2">Paste the full iframe code provided by Viloud. The player will automatically scale to 16:9 ratio on the frontend.</p>
        </div>

        <div className="pt-4 border-t border-dark-border flex items-center justify-between">
          {saved ? (
            <span className="text-green-400 text-sm flex items-center"><SafeIcon name="Check" className="w-4 h-4 mr-1" /> Settings saved successfully</span>
          ) : <span></span>}
          <button 
            type="submit" 
            className="bg-rocket hover:bg-rocket-hover text-white px-6 py-2 rounded-md font-semibold transition-colors"
          >
            Save Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLive;